import type { Unternehmen } from "@kundeninfo/api-client";

/**
 * Die Hausfarbe eines Unternehmens für seinen Kürzel-Chip (Entscheid 41, Dirk 17.10.2026).
 *
 * Seit me-design 05bead9 trägt `me-chip` die Hausfarbe selbst (`farbe="#hex"`): Fläche und eine
 * in beiden Schemata lesbare Schrift leitet das Element ab (rahmenlos: Der Rand gehört nur dem
 * entfernbaren Chip, Kennzeichen-Regel). Hier stand bis P16 eine eigene Tönung
 * (`markenTextfarben` + `::part(chip)`, Übergang P4-4) — sie ist weg; die Kundeninfo sucht
 * nur noch die Farbe heraus. Einen krummen Wert lässt der Chip neutral.
 */
export function hausfarbe(
  companies: readonly Pick<Unternehmen, "shortCode" | "colorHex">[] | undefined,
  shortCode: string,
): string | undefined {
  return companies?.find((c) => c.shortCode === shortCode)?.colorHex;
}

/** Dieselbe Farbe als Eigenschaft für `<Chip {...hausfarbeChip(…)}>`; ohne Farbe leer. */
export function hausfarbeChip(
  companies: readonly Pick<Unternehmen, "shortCode" | "colorHex">[] | undefined,
  shortCode: string,
): { farbe?: string } {
  const farbe = hausfarbe(companies, shortCode);
  return farbe === undefined ? {} : { farbe };
}
